// 공식·공신력 출처만. 학원·개인 블로그 제외.
// tracks: eju | general | mext | all
// fields: stem | medicine | humanities | all

export const officialResourceCategories = [
  { id: 'all', label: '전체' },
  { id: 'eju', label: 'EJU·유학생' },
  { id: 'general', label: '일반입시' },
  { id: 'mext', label: '국비(MEXT)' },
  { id: 'visa', label: '비자·체류' },
  { id: 'univ', label: '대학 요강' },
];

export const officialResources = [
  {
    id: 'jasso-eju',
    category: 'eju',
    tracks: ['eju'],
    fields: ['stem', 'medicine', 'humanities'],
    name: '일본유학시험(EJU)',
    org: 'JASSO',
    why: '시험 개요·일정·과목·출원·성적 확인의 1차 공식 창구',
    url: 'https://www.jasso.go.jp/ryugaku/eju/index.html',
    lang: 'JA',
  },
  {
    id: 'jasso-eju-syllabus-revision',
    category: 'eju',
    tracks: ['eju'],
    fields: ['stem', 'medicine', 'humanities'],
    name: 'EJU 시라버스 개정 안내',
    org: 'JASSO',
    why: '2026년도 제1회부터 기초학력(이과·종합·수학) 출제범위 개정 개요',
    url: 'https://www.jasso.go.jp/ryugaku/eju/about/revision/index.html',
    lang: 'JA',
  },
  {
    id: 'jasso-eju-syllabus-2026',
    category: 'eju',
    tracks: ['eju'],
    fields: ['stem', 'medicine', 'humanities'],
    name: 'EJU 기초학력 시라버스(2026 제1회~)',
    org: 'JASSO',
    why: '개정 포인트·대비표·과목별 시라버스 링크(물리·화학·생물·종합·수학)',
    url: 'https://www.jasso.go.jp/ryugaku/eju/about/revision/rev_basic.html',
    lang: 'JA',
  },
  {
    id: 'jasso-eju-en',
    category: 'eju',
    tracks: ['eju'],
    fields: ['stem', 'medicine', 'humanities'],
    name: 'EJU (English)',
    org: 'JASSO',
    why: 'EJU 영문 안내·해외 응시 정보',
    url: 'https://www.jasso.go.jp/en/ryugaku/eju/index.html',
    lang: 'EN',
  },
  {
    id: 'studyinjapan-home',
    category: 'eju',
    tracks: ['eju', 'mext', 'general'],
    fields: ['stem', 'medicine', 'humanities'],
    name: 'Study in Japan',
    org: 'JASSO / MEXT 연계 포털',
    why: '유학 계획·장학금·입시 절차 종합 공식 포털',
    url: 'https://www.studyinjapan.go.jp/ja/',
    lang: 'JA',
  },
  {
    id: 'studyinjapan-en',
    category: 'eju',
    tracks: ['eju', 'mext'],
    fields: ['stem', 'medicine', 'humanities'],
    name: 'Study in Japan (EN)',
    org: 'JASSO / MEXT 연계 포털',
    why: '영문 유학·장학금 안내',
    url: 'https://www.studyinjapan.go.jp/en/',
    lang: 'EN',
  },
  {
    id: 'studyinjapan-mext-undergrad',
    category: 'mext',
    tracks: ['mext'],
    fields: ['stem', 'medicine', 'humanities'],
    name: 'MEXT 학부 · Embassy Recommendation',
    org: 'Study in Japan',
    why: '대사관 추천 학부 국비 출원 가이드·양식 링크',
    url: 'https://www.studyinjapan.go.jp/en/smap-stopj-applications-undergraduate.html',
    lang: 'EN',
  },
  {
    id: 'mext-exam-past',
    category: 'mext',
    tracks: ['mext'],
    fields: ['stem', 'medicine', 'humanities'],
    name: 'MEXT 선발 시험 기출',
    org: 'Study in Japan',
    why: '대사관 추천 필기 대비용 공식 기출 안내',
    url: 'https://www.studyinjapan.go.jp/en/planning/scholarship/application/examination/index.html',
    lang: 'EN',
  },
  {
    id: 'embassy-kr-mext',
    category: 'mext',
    tracks: ['mext'],
    fields: ['stem', 'medicine', 'humanities'],
    name: '일본문부과학성 국비유학생',
    org: '주한일본대사관',
    why: '한국 지원자용 국비 종류·월액·신청 경로 (연도별 공고 확인)',
    url: 'https://www.kr.emb-japan.go.jp/itpr_ko/study_government.html',
    lang: 'KO',
  },
  {
    id: 'embassy-kr-mext-news',
    category: 'mext',
    tracks: ['mext'],
    fields: ['stem', 'medicine', 'humanities'],
    name: '국비 모집 안내(최신 공고 목록)',
    org: '주한일본대사관',
    why: '해당 연도 모집 요강·일정은 공고 원문 우선',
    url: 'https://www.kr.emb-japan.go.jp/itpr_ko/news_20250509.html',
    lang: 'KO',
  },
  {
    id: 'dnc-kyotsu',
    category: 'general',
    tracks: ['general'],
    fields: ['stem', 'medicine', 'humanities'],
    name: '대학입학공통테스트',
    org: '대학입시센터(DNC)',
    why: '일반입시 공통테스트 개요·시험 정보',
    url: 'https://www.dnc.ac.jp/kyotsu/',
    lang: 'JA',
  },
  {
    id: 'dnc-web-apply',
    category: 'general',
    tracks: ['general'],
    fields: ['stem', 'medicine', 'humanities'],
    name: '공통테스트 Web 출원 안내',
    org: '대학입시센터(DNC)',
    why: '출원 일정·마이페이지 절차',
    url: 'https://www.dnc.ac.jp/kyotsu/web_syutugan.html',
    lang: 'JA',
  },
  {
    id: 'immigration-studyinjapan',
    category: 'visa',
    tracks: ['eju', 'general', 'mext'],
    fields: ['stem', 'medicine', 'humanities'],
    name: '입국 절차·재류자격',
    org: 'Study in Japan',
    why: 'COE·유학 비자 흐름 공식 설명',
    url: 'https://www.studyinjapan.go.jp/ja/planning/immigration-procedures/',
    lang: 'JA',
  },
  {
    id: 'moj-isa',
    category: 'visa',
    tracks: ['eju', 'general', 'mext'],
    fields: ['stem', 'medicine', 'humanities'],
    name: '출입국재류관리청',
    org: '일본 법무성 ISA',
    why: '재류자격·신청 서식 등 법령·행정 원문',
    url: 'https://www.moj.go.jp/isa/',
    lang: 'JA',
  },
  {
    id: 'jasso-scholarship-honors',
    category: 'eju',
    tracks: ['eju'],
    fields: ['stem', 'medicine', 'humanities'],
    name: '학습장려비 예약(사전입학)',
    org: 'JASSO',
    why: '渡日前 입학과 연계된 문부과학성 학습장려비(사비) 예약 — 학교 경유 절차',
    url: 'https://www.jasso.go.jp/en/ryugaku/scholarship_j/shoreihi/yoyaku_tonichimae.html',
    lang: 'EN',
  },
  {
    id: 'jasso-prearrival-schools',
    category: 'eju',
    tracks: ['eju'],
    fields: ['stem', 'medicine', 'humanities'],
    name: 'EJU 이용 渡日前入学許可校',
    org: 'JASSO',
    why: '해외에서 전형·허가가 가능한 EJU 이용 학교 목록(수시 갱신·요강 최종)',
    url: 'https://www.jasso.go.jp/ryugaku/eju/examinee/prearrival/index.html',
    lang: 'JA',
  },
  {
    id: 'u-tokyo-intl',
    category: 'univ',
    tracks: ['eju', 'general'],
    fields: ['stem', 'medicine', 'humanities'],
    name: '도쿄대 유학생·입시',
    org: '도쿄대학',
    why: '국립 상위권 요강·유학생 전형 확인 예시',
    url: 'https://www.u-tokyo.ac.jp/ja/admissions/index.html',
    lang: 'JA',
  },
  {
    id: 'kyoto-intl',
    category: 'univ',
    tracks: ['eju', 'general'],
    fields: ['stem', 'medicine', 'humanities'],
    name: '교토대 입시',
    org: '교토대학',
    why: '국립대 모집요항 확인 예시',
    url: 'https://www.kyoto-u.ac.jp/ja/admissions',
    lang: 'JA',
  },
  {
    id: 'hokudai-intl',
    category: 'univ',
    tracks: ['eju', 'general'],
    fields: ['stem', 'medicine', 'humanities'],
    name: '홋카이도대 입시',
    org: '홋카이도대학',
    why: '지방 국립·이공/의 계열 요강 확인 예시',
    url: 'https://www.hokudai.ac.jp/admission/',
    lang: 'JA',
  },
  {
    id: 'tohoku-intl',
    category: 'univ',
    tracks: ['eju', 'general'],
    fields: ['stem', 'medicine', 'humanities'],
    name: '도호쿠대 입시',
    org: '도호쿠대학',
    why: '구제국대·국립 이공/의문 요강 허브',
    url: 'https://admissions.tohoku.ac.jp/ja/',
    lang: 'JA',
  },
  {
    id: 'nagoya-intl',
    category: 'univ',
    tracks: ['eju', 'general'],
    fields: ['stem', 'medicine', 'humanities'],
    name: '나고야대 입시',
    org: '나고야대학',
    why: '중부 국립·사비외국인·일반선발 요강',
    url: 'https://www.nagoya-u.ac.jp/admissions/',
    lang: 'JA',
  },
  {
    id: 'kyushu-intl',
    category: 'univ',
    tracks: ['eju', 'general'],
    fields: ['stem', 'medicine', 'humanities'],
    name: '규슈대 입시',
    org: '규슈대학',
    why: '규슈권 국립 학부·유학생 전형',
    url: 'https://www.kyushu-u.ac.jp/ja/admission/',
    lang: 'JA',
  },
  {
    id: 'waseda-intl',
    category: 'univ',
    tracks: ['eju', 'general'],
    fields: ['stem', 'humanities', 'medicine'],
    name: '와세다대 입시',
    org: '와세다대학',
    why: '사립 유학생·학부별 요강 분리 예시',
    url: 'https://www.waseda.jp/inst/admission/',
    lang: 'JA',
  },
  {
    id: 'keio-intl',
    category: 'univ',
    tracks: ['eju', 'general'],
    fields: ['stem', 'humanities', 'medicine'],
    name: '게이오대 입시',
    org: '게이오의숙대학',
    why: '사립 AO·유학생·학부 전형 요강',
    url: 'https://www.keio.ac.jp/ja/admissions/',
    lang: 'JA',
  },
  {
    id: 'hit-intl',
    category: 'univ',
    tracks: ['eju', 'general'],
    fields: ['humanities'],
    name: '히토쓰바시대 입시',
    org: '히토쓰바시대학',
    why: '사회과학 국립 학부 요강',
    url: 'https://www.hit-u.ac.jp/admission/',
    lang: 'JA',
  },
  {
    id: 'tus-intl',
    category: 'univ',
    tracks: ['eju', 'general'],
    fields: ['stem'],
    name: '도쿄이과대 입시',
    org: '도쿄이과대학',
    why: '이공 사립 admissions 허브',
    url: 'https://www.tus.ac.jp/admissions/',
    lang: 'JA',
  },
  {
    id: 'ritsumeikan-intl',
    category: 'univ',
    tracks: ['eju', 'general'],
    fields: ['stem', 'humanities'],
    name: '리츠메이칸대 입시',
    org: '리츠메이칸대학',
    why: '간사이 사립·유학생·AO 요강',
    url: 'https://admission.ritsumei.ac.jp/',
    lang: 'JA',
  },
  {
    id: 'meiji-intl',
    category: 'univ',
    tracks: ['eju', 'general'],
    fields: ['stem', 'humanities'],
    name: '메이지대 입시',
    org: '메이지대학',
    why: '도쿄 사립 학부·유학생 요강',
    url: 'https://www.meiji.ac.jp/exam/',
    lang: 'JA',
  },
  {
    id: 'sapmed-intl',
    category: 'univ',
    tracks: ['eju', 'general'],
    fields: ['medicine'],
    name: '삿포로의과대 입시',
    org: '삿포로의과대학',
    why: '공립 의계 요강 확인 예시(전형 유무는 연도별)',
    url: 'https://web.sapmed.ac.jp/',
    lang: 'JA',
  },
];

/** 루트 파인더 결과와 매칭할 공식 링크 id */
export const routeResourceMap = {
  'eju-stem': [
    'jasso-eju',
    'jasso-eju-syllabus-revision',
    'jasso-eju-syllabus-2026',
    'studyinjapan-home',
    'hokudai-intl',
    'tohoku-intl',
    'tus-intl',
    'immigration-studyinjapan',
  ],
  'eju-medicine': [
    'jasso-eju',
    'jasso-eju-syllabus-2026',
    'u-tokyo-intl',
    'kyoto-intl',
    'sapmed-intl',
    'immigration-studyinjapan',
  ],
  'eju-humanities': [
    'jasso-eju',
    'jasso-eju-syllabus-2026',
    'studyinjapan-home',
    'u-tokyo-intl',
    'hit-intl',
    'keio-intl',
  ],
  'general-stem': ['dnc-kyotsu', 'dnc-web-apply', 'hokudai-intl', 'kyushu-intl', 'nagoya-intl'],
  'general-medicine': ['dnc-kyotsu', 'dnc-web-apply', 'u-tokyo-intl', 'kyoto-intl', 'sapmed-intl'],
  'general-humanities': ['dnc-kyotsu', 'dnc-web-apply', 'kyoto-intl', 'hit-intl', 'meiji-intl'],
  'mext-stem': [
    'embassy-kr-mext',
    'embassy-kr-mext-news',
    'studyinjapan-mext-undergrad',
    'mext-exam-past',
  ],
};

export function resourcesForRoute(routeId) {
  const ids = routeResourceMap[routeId] || [];
  return ids
    .map((id) => officialResources.find((r) => r.id === id))
    .filter(Boolean);
}
